// 日刻代理商支付
import React, { useEffect, useState, useRef, Component } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams, Route } from "react-router-dom";
import { inWeixin } from 'web-launch-app';
import moment from 'moment';
import { Toast } from "antd-mobile";
import '../css/RikeAgentPay.scss';
import RikeService from "../services/Rike";
import { getParameter, addZero } from "../utils/func";
import classNames from 'classnames';

const RikeAgentPay = ({ props }) => {
    let match = useRouteMatch();
    let location = useLocation();
    let history = useHistory();
    let params = useParams();
    const APPID = 'wx754e1b2a81936e91' // appid
    const [user, setUser] = useState({});
    const [orderData, setOrderData] = useState({});
    const [timer, setTimer] = useState(null);
    const [isActivity, setIsActivity] = useState(true);
    const [priceList, setPriceList] = useState([]);
    const [type, setType] = useState("5");
    useEffect(() => {
        document.title = "优惠购";
        document.body.style = "background: #fff;"
        const token = getParameter("token", location.search);
        RikeService.getSharePriceList({ share_token: token }).then(res => {
            setPriceList(res.data.order_settings);
        }).catch(error => error.message && Toast.info(error.message))
    }, []);
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    const openTodoApp = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.replace("https://www.kairusi.com/thinkdiary");
            } else if (browser.versions.android) {
                window.location.replace("https://www.kairusi.com/thinkdiary");
            }
            // window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
        }
    };
    useEffect(() => {
        const code = getParameter("code");
        if (code && inWeixin) {
            isRegister();
        }
    }, []);
    useEffect(() => {
        return () => {
            // clearInterval(timer);
        };
    })
    // 微信授权
    const toWxpayAuth = () => {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile/#" + location.pathname + location.search + '&orderType=' + type)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };
    // 是否注册过
    const isRegister = () => {
        const code = getParameter("code");
        RikeService.checkRegister({ code }).then(res => {
            // if (res.data.u_id === "0") {
            //     openTodoApp();
            // } else {
            //     setUser(res.data);
            //     createOrder(res.data);
            // }
            setUser(res.data);
            createOrder(res.data);
        }).catch(error => error.message && Toast.info(error.message))
    };
    // 创建订单
    const createOrder = (userObject) => {
        const token = getParameter("token", location.search);
        const orderType = getParameter("orderType", location.search);
        RikeService.createOrderAgent({ type: orderType, unionid: userObject.wx_unionid, u_id: userObject.u_id, openid: userObject.openid, share_token: token }).then(res => {
            setOrderData(res.data);
            localStorage.setItem("orderWx", JSON.stringify(res.data));
            toPay(res.data);
        }).catch(error => {
            error.message && Toast.info(error.message, 3);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/agent-pay?token=" + token);
            }, 3000);
        })
    };
    // 查询订单
    const getOrderStatus = () => {
        const token = getParameter("token", location.search);
        RikeService.getOrderStatus({ order_sn: JSON.parse(localStorage.getItem("orderWx")).order_sn }).then(payInfo => {
            if (payInfo.data.status === 1) {
                clearInterval(timer);
                localStorage.removeItem("orderWx");
                Toast.info('购买成功', 2);
                setTimeout(() => {
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/agent-pay?token=" + token);
                }, 2000);
            }
        }).catch(error => {
            error.message && Toast.info(error.message, 2);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/agent-pay?token=" + token);
            }, 2000);
        })
    };
    const onBridgeReady = (wxpayData) => {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
            "appId": wxpayData.appid,     //公众号名称，由商户传入     
            "timeStamp": wxpayData.timestamp,         //时间戳，自1970年以来的秒数     
            "nonceStr": wxpayData.nonce_str, //随机串     
            // "package": "prepay_id=" + wxpayData.prepay_id,
            "package": wxpayData.package,
            "signType": "MD5",         //微信签名方式：     
            "paySign": wxpayData.sign //微信签名 
        },
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (localStorage.getItem("orderWx") && JSON.parse(localStorage.getItem("orderWx")).order_sn) {
                        setTimer(setInterval(() => {
                            getOrderStatus();
                        }, 1000))
                    }
                } else {
                    const token = getParameter("token", location.search);
                    localStorage.removeItem("orderWx");
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/rike/agent-pay?token=" + token);
                }
            });
    };
    // 立即支付
    const toPay = (wxpayData) => {
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady(wxpayData), false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady(wxpayData));
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(wxpayData));
            }
        } else {
            onBridgeReady(wxpayData);
        }
    };

    return (
        <div className="active agent-pay">
            <img className="agent-pay-top" src={require('../image/rike/agent-pay-bg.png')} />
            <div className="price-box">
                <div className="price-list">
                    {
                        priceList.length > 0 && priceList.map((item, i) => {
                            return <div
                            className={classNames("price-item", { "price-item-active": item.type === type })}
                            key={i}
                            onClick={() => setType(item.type)}
                            >
                                <div className={classNames("price-title")}>{item.content_header}</div>
                                <div className="price-num">
                                    <div className="current-price">
                                        <span className="current-price-unit">¥</span>
                                        <span className="current-price-num">{item.money}</span>
                                    </div>
                                    <div className="old-pricce">原价{item.old_money}</div>
                                </div>
                                <div className="price-text">{item.content_footer}</div>
                            </div>
                        })
                    }
                    <div className="agent-pay-button" onClick={toWxpayAuth}>立即抢购</div>
                </div>
            </div>
        </div>
    )
};

export default RikeAgentPay;